import React, { useState, useContext, useEffect, useRef } from "react";
import styled from "styled-components";
import { motion, AnimatePresence } from "framer-motion";
import { DirectionContext } from "../App";
import Cookies from "js-cookie";
import API_ENDPOINTS from "../config/api";
import { saveInitialTermsToLocal } from "../config/termsAgreement";

// 카카오 인증 고정 (인증수단 선택 UI 제거)
const KAKAO_AUTH_METHOD = {
  value: "kakao",
  label: "카카오",
  icon: "/png/kakaoIcon.png",
};

// 이용약관 JSX 컴포넌트
const TermsContent = () => (
  <TermsContentContainer>
    <TermsSectionTitle>
      「결혼정보업체 듀오 개인정보 유출 피해 집단소송 참여 접수」 이용약관
    </TermsSectionTitle>

    <TermsSection>
      <TermsSectionTitle>제1조 (목적)</TermsSectionTitle>
      <TermsText>
        본 약관은 법무법인 더 에이치 황해(이하 "회사")가 운영하는 인터넷 웹
        서비스 플랫폼 「결혼정보업체 듀오 개인정보 유출 피해 집단소송 참여
        접수」(이하 "플랫폼")의 이용과 관련하여 회사와 이용자의 권리·의무 및
        책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
      </TermsText>
    </TermsSection>

    <TermsSection>
      <TermsSectionTitle>제2조 (정의)</TermsSectionTitle>
      <TermsText>
        ① 본 약관에서 사용하는 용어의 정의는 다음과 같습니다.
      </TermsText>
      <TermsList>
        <li>
          "듀오"란 듀오정보 주식회사가 운영하는 결혼정보 서비스를 의미합니다.
        </li>
        <li>
          "서비스"란 이용자가 단말기(PC, 모바일 등)를 통해 플랫폼에 접속하여
          듀오 개인정보 유출 사건과 관련한 집단소송 참여 접수를 하고, 회사가
          정하는 경우 추가 자료 제출, 유의사항 확인,
          소송위임계약서·소송위임장·전자서명 이미지 사용 및 활용 동의서 등 관련
          문서의 동의, 전자서명, 신분증 제출, 비용 결제 기타 이에 부수하는
          절차를 진행할 수 있도록 제공되는 온라인 서비스를 의미합니다.
        </li>
        <li>
          "이용자"란 플랫폼에 접속하여 본 약관에 동의하고 서비스를 이용하는 자를
          의미합니다.
        </li>
        <li>
          "참여 접수"란 이용자가 플랫폼을 통해 집단소송 참여 의사를 표시하고,
          회사가 요구하는 정보 및 자료를 제출하여 접수를 완료하는 절차를
          의미합니다.
        </li>
        <li>
          "본인인증"이란 참여 접수 과정에서 이용자의 신원을 확인하기 위하여
          「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 제23조의3에 따른
          본인확인기관(카카오 본인인증 서비스를 포함한다)의 인증 절차를 통해
          수행하는 본인 확인 절차를 의미합니다.
        </li>
        <li>
          "듀오 가입 입증 자료"란 이용자가 듀오 서비스 가입 사실 및 가입
          내역(가입 유형 — 무료회원/유료회원 구분, 가입비용, 가입일자 등)을
          입증하기 위하여 제출하는 자료로서, 가입 안내문, 결제 내역, 화면 캡처,
          이메일, 문자, 기타 관련 자료 일체를 의미합니다.
        </li>
        <li>
          "소송위임계약"이란 이용자가 회사와 듀오 개인정보 유출 사건의 소송
          수행을 위하여 별도로 체결하는 계약(개인정보보호법령상 분쟁 조정절차의
          대리를 포함한다)을 의미하며, 소송위임계약서, 소송위임장, 전자서명
          이미지 사용 및 활용 동의서, 개인정보 수집·이용 동의 등 관련 부속
          문서를 포함합니다.
        </li>
        <li>
          "전자적 자필 서명"이란 이용자가 태블릿·스마트폰 등 전자기기를 통하여
          직접 입력한 자필 서명 등 전자적 방식으로 본인의 서명 의사를 표시하는
          행위를 의미합니다.
        </li>
        <li>
          "전자적 인장"이란 전자적 방식으로 조각·생성된 인장을 의미합니다.
        </li>
      </TermsList>
    </TermsSection>

    <TermsSection>
      <TermsSectionTitle>제3조 (약관의 게시 및 개정)</TermsSectionTitle>
      <TermsText>
        ① 회사는 본 약관의 내용을 플랫폼 초기 화면 또는 연결 화면에 게시하여
        이용자가 쉽게 확인할 수 있도록 합니다.
      </TermsText>
      <TermsText>
        ② 회사는 「약관의 규제에 관한 법률」, 「전자상거래 등에서의 소비자보호에
        관한 법률」 등 관계 법령을 위반하지 않는 범위에서 본 약관을 개정할 수
        있습니다.
      </TermsText>
      <TermsText>
        ③ 회사가 본 약관을 개정하는 경우 개정 내용과 시행일을 명시하여 시행일
        7일 전부터 플랫폼에 공지합니다. 다만 이용자에게 불리한 변경 또는 중요한
        변경의 경우에는 시행일 30일 전부터 공지하고, 별도의 동의 절차를
        거칩니다.
      </TermsText>
      <TermsText>
        ④ 이용자가 개정 약관에 동의하지 않는 경우 서비스 이용을 중단하고 참여
        접수의 철회 기타 필요한 조치를 요청할 수 있습니다. 회사는 제3항에 따른
        공지 시 이용자가 시행일까지 명시적인 거부 의사를 표시하지 아니하면 개정
        약관에 동의한 것으로 본다는 뜻을 함께 고지하며, 시행일 이후에도 이용자가
        서비스를 계속 이용하는 경우 개정 약관에 동의한 것으로 봅니다. 다만
        소송위임계약이 이미 체결된 이후의 사항에 관하여는 해당 계약의 내용에
        따릅니다.
      </TermsText>
    </TermsSection>

    <TermsSection>
      <TermsSectionTitle>제4조 (서비스의 내용)</TermsSectionTitle>
      <TermsText>
        ① 플랫폼에서 제공하는 서비스는 듀오 개인정보 유출 사건과 관련한 집단소송
        참여 접수 및 이에 부수하는 온라인 절차의 제공입니다.
      </TermsText>
      <TermsText>
        ② 이용자는 회사가 정하는 절차와 방법에 따라 다음 각 호에 해당하는 사항을
        순차로 진행합니다. 회사는 사건의 진행 상황, 운영상의 필요, 관계 법령의
        변경 등을 고려하여 절차의 내용·순서·방법을 추가, 변경 또는 생략할 수
        있습니다.
      </TermsText>
      <TermsList>
        <li>이용자 정보의 입력 및 본인 확인</li>
        <li>사건 관련 정보 및 자료의 제출</li>
        <li>약관·계약서·동의서 등 관련 문서의 확인 및 동의</li>
        <li>전자서명 및 본인확인 자료의 제출</li>
        <li>비용 결제 및 접수 완료</li>
      </TermsList>
      <TermsText>
        ③ 참여 접수 시 이용자가 제출하여야 하는 정보 및 자료의 구체적인 항목,
        수집 목적, 보유기간, 제3자 제공 여부, 처리 위탁 등은 별도의 개인정보
        처리방침 및 플랫폼 내 안내에 따릅니다.
      </TermsText>
      <TermsText>
        ④ 회사는 참여 접수 이후 사건 검토, 듀오 가입 사실 및 가입 내역 확인,
        자료 보완 요청, 추가 자료 제출 요청, 소송 진행 상황 안내 기타 사건
        진행을 위하여 필요한 절차를 플랫폼 또는 회사가 정한 방법으로 제공할 수
        있습니다.
      </TermsText>
      <TermsText>
        ⑤ 본 서비스는 결제 단계에서 소송위임계약의 체결과 비용 결제가 함께
        이루어지며, 결제가 완료됨과 동시에 회사는 소송위임계약에 따른 위임사무에
        즉시 착수합니다. 결제 이후의 계약 해지·취소·환불 등은 소송위임계약서 및
        관계 법령에서 정한 바에 따릅니다.
      </TermsText>
      <TermsText>
        ⑥ 회사는 만 19세 미만 미성년자의 참여 접수를 받지 아니하며, 미성년자에
        의한 신청이 확인되는 경우 해당 접수를 거부하거나 취소합니다.
      </TermsText>
    </TermsSection>

    <TermsSection>
      <TermsSectionTitle>제5조 (서비스의 제공 및 운영)</TermsSectionTitle>
      <TermsText>
        ① 회사는 플랫폼의 접속, 참여 접수 및 회사가 정하는 후속 절차를
        원칙적으로 비대면 온라인 형태로 제공하며, 안정적인 서비스 제공을 위하여
        노력합니다.
      </TermsText>
      <TermsText>
        ② 회사는 시스템 정기점검, 장애, 통신상의 문제, 기타 불가피한 사유로
        서비스 제공이 일시 중단될 수 있으며, 이 경우 사전에 공지합니다. 다만
        부득이한 사정으로 사전 공지가 어려운 경우 사후 지체 없이 공지합니다.
      </TermsText>
      <TermsText>
        ③ 회사는 집단소송의 진행 상황, 접수 마감, 사건 운영상의 필요, 기타
        상당한 사유가 있는 경우 참여 접수 또는 후속 절차의 제공을 종료하거나
        제한할 수 있으며, 이 경우 사전에 공지합니다.
      </TermsText>
      <TermsText>
        ④ 회사는 플랫폼의 안정적 운영을 위하여 시스템 개발·운영 등 일부 업무를
        외부 사업자에게 위탁할 수 있으며, 위탁 업무의 범위, 수탁자 등 구체적인
        사항은 회사의 개인정보 처리방침에 따릅니다. 외부 수탁자는 시스템 운영 등
        회사가 위탁한 업무에 한하여 관여하며, 법률 자문·상담 기타 법률사무에는
        일체 관여하지 아니합니다.
      </TermsText>
    </TermsSection>

    <TermsSection>
      <TermsSectionTitle>제6조 (참여 접수의 완료 및 확인)</TermsSectionTitle>
      <TermsText>
        ① 이용자는 제4조 제2항에 따른 절차를 모두 완료한 때 참여 접수가
        완료됩니다.
      </TermsText>
      <TermsText>
        ② 회사는 접수된 참여 내용 및 제출 자료의 확인 및 검토를 진행하며, 다음
        각 호에 해당하는 경우 접수를 거부하거나 접수 완료 후에도 이를 취소할 수
        있습니다.
      </TermsText>
      <TermsList>
        <li>타인의 명의를 도용하여 신청한 경우</li>
        <li>허위 정보를 기재하거나 허위·위조·변조된 자료를 제출한 경우</li>
        <li>동일인이 중복하여 신청한 경우</li>
        <li>
          본인인증 또는 신분증 제출 등 회사가 요구하는 본인 확인 절차를 완료하지
          않은 경우
        </li>
        <li>
          제출한 정보 또는 자료만으로 신청인의 신원, 듀오 가입 사실 또는 접수
          요건을 확인하기 어려운 경우
        </li>
        <li>
          듀오 개인정보 유출 사건의 대상자 범위에 해당하지 않거나 해당 여부를
          확인할 수 없는 경우
        </li>
        <li>미성년자가 신청한 경우</li>
        <li>기타 객관적·합리적 사유로 접수 요건을 충족하지 못하는 경우</li>
      </TermsList>
      <TermsText>
        ③ 회사는 참여 접수 이후 듀오 가입 내역, 자료 보완 필요성, 대상자 해당
        여부 등을 별도로 확인하거나 안내할 수 있습니다.
      </TermsText>
    </TermsSection>

    <TermsSection>
      <TermsSectionTitle>제7조 (참여 접수의 철회)</TermsSectionTitle>
      <TermsText>
        ① 이용자는 결제 및 소송위임계약 체결 이전 단계까지 회사에 의사를
        표시하여 참여 접수의 철회를 요청할 수 있습니다.
      </TermsText>
      <TermsText>
        ② 결제 및 소송위임계약 체결이 완료된 이후의 계약 해지·취소·환불 등은
        제8조 및 소송위임계약서가 정하는 바에 따르며, 본 조에 따른 철회의 대상이
        되지 아니합니다.
      </TermsText>
      <TermsText>
        ③ 철회 요청은 플랫폼 내 별도 안내된 방법, 고객문의 채널, 전자우편, 전화,
        기타 회사가 안내하는 방법으로 할 수 있습니다.
      </TermsText>
      <TermsText>
        ④ 회사는 특별한 사정이 없는 한 철회 요청을 접수한 날로부터 영업일 기준
        3일 이내에 처리합니다.
      </TermsText>
      <TermsText>
        ⑤ 참여 접수 철회 시 이용자가 제출한 정보 및 자료는 관계 법령, 개인정보
        처리방침 및 회사의 내부 기준에 따라 처리됩니다.
      </TermsText>
    </TermsSection>

    <TermsSection>
      <TermsSectionTitle>제8조 (소송위임계약, 결제 및 환불)</TermsSectionTitle>
      <TermsText>
        ① 본 서비스의 결제 단계에서는 소송위임계약의 체결과 착수비용의 결제가
        함께 이루어집니다. 회사는 결제 및 전자서명에 앞서 이용자에게
        소송위임계약서, 소송위임장, 전자서명 이미지 사용 및 활용 동의서 등 주요
        문서의 내용을 확인할 수 있도록 안내하고, 비용·결제 방법·환불 기준 등
        주요 사항을 별도로 고지합니다.
      </TermsText>
      <TermsText>
        ② 결제가 완료됨과 동시에 회사는 소송위임계약에 따른 위임사무(사건
        검토·자료 분석·당사자 확인 등 소송 준비행위를 포함합니다)에 즉시
        착수합니다. 이러한 점을 고려하여 이용자는 결제 완료 이후 회사에
        착수비용의 반환을 청구할 수 없으며, 환불은 소송위임계약서 및 관계
        법령에서 정한 사유에 한정됩니다. 다만 회사의 귀책사유로 인하여
        위임사무가 종료된 경우 또는 관계 법령상 이용자의 정당한 해지 사유가
        인정되는 경우에는 그러하지 아니합니다.
      </TermsText>
      <TermsText>
        ③ 성공보수금, 추가비용, 정산 방법 등 소송 수행과 관련한 비용·정산에 관한
        사항은 소송위임계약서가 정하는 바에 따릅니다.
      </TermsText>
      <TermsText>
        ④ 회사는 결제에 대하여 관계 법령이 정하는 바에 따라 영수증 또는 결제
        확인 정보를 제공합니다.
      </TermsText>
    </TermsSection>

    <TermsSection>
      <TermsSectionTitle>
        제9조 (전자문서, 전자적 서명 및 전자적 인장)
      </TermsSectionTitle>
      <TermsText>
        ① 회사는 소송위임계약서, 소송위임장, 전자서명 이미지 사용 및 활용
        동의서, 개인정보 수집·이용 동의서 기타 관련 문서를 전자문서의 형태로
        제공할 수 있으며, 해당 전자문서는 관계 법령에 따라 종이 문서와 동일한
        효력을 가집니다.
      </TermsText>
      <TermsText>
        ② 이용자는 회사가 안내하는 절차에 따라 전자적 자필 서명을 할 수 있으며,
        해당 전자적 자필 서명은 종이 서면에 한 자필 서명과 동일한 효력을
        가집니다.
      </TermsText>
      <TermsText>
        ③ 이용자는 회사가 본 서비스 및 소송위임계약에 따른 소송위임장,
        소장·준비서면 등 소송서류의 제출, 판결금 등의 수령 기타 사건 수행을
        위하여 필요한 경우, 이용자의 전자적 자필 서명(이미지 형태로 저장된
        서명을 포함합니다)을 복제·삽입·사용하는 것에 동의하며, 회사는 본 서비스
        및 소송위임계약 수행에 직접 필요한 범위에서만 이를 사용합니다.
      </TermsText>
      <TermsText>
        ④ 이용자는 회사가 본 서비스 및 소송위임계약에 따른 소송위임장,
        소장·준비서면 등 소송서류의 제출, 판결금 등의 수령 기타 사건 수행을
        위하여 필요한 경우, 이용자의 전자적 인장을 조각·사용하는 것에 동의하며,
        회사는 본 서비스 및 소송위임계약 수행에 직접 필요한 범위에서만 이를
        사용합니다.
      </TermsText>
      <TermsText>
        ⑤ 전자적 자필 서명 및 전자적 인장의 사용 범위와 방법, 보관, 폐기 등에
        관한 사항은 소송위임계약서 및 전자서명 이미지 사용 및 활용 동의서가
        정하는 바에 따르며, 회사는 본 서비스 및 소송위임계약의 목적을 벗어나
        이를 사용하지 아니합니다.
      </TermsText>
      <TermsText>
        ⑥ 회사는 분쟁의 예방 및 해결을 위하여 본인인증 결과, 전자적 자필 서명
        이미지, 신분증 사본, 동의 시점·기기·접속 정보(IP 등) 등 본 서비스의
        진행에 관한 기록을 관계 법령 및 개인정보 처리방침에서 정하는 기간 동안
        보관할 수 있습니다.
      </TermsText>
      <TermsText>
        ⑦ 전자적 자필 서명 및 전자적 인장의 구체적인 방식, 보관, 활용 등에 관한
        사항은 소송위임계약서, 별도 동의서 또는 플랫폼 내 안내에 따릅니다.
      </TermsText>
    </TermsSection>

    <TermsSection>
      <TermsSectionTitle>제10조 (이용자의 의무)</TermsSectionTitle>
      <TermsText>
        ① 이용자는 서비스 이용과 관련하여 다음 각 호의 행위를 하여서는 아니
        됩니다.
      </TermsText>
      <TermsList>
        <li>타인의 정보 도용 또는 허위 정보 기재</li>
        <li>타인의 개인정보, 권리 또는 법적 이익을 침해하는 자료 제출</li>
        <li>제출 권한이 없는 자료 또는 위조·변조된 자료의 제출</li>
        <li>회사의 저작권 및 지식재산권 침해</li>
        <li>서비스 운영을 방해하는 행위</li>
        <li>법령 위반 또는 공서양속을 해치는 행위</li>
      </TermsList>
      <TermsText>
        ② 이용자는 참여 접수 및 후속 절차 진행 시 정확하고 진실한 정보를
        제공하여야 하며, 제출 정보에 변경이 있는 경우 지체 없이 회사에 알려야
        합니다.
      </TermsText>
      <TermsText>
        ③ 이용자는 자신이 제출하는 듀오 가입 입증 자료, 신분증 사본 기타 자료에
        대하여 적법한 제출 권한을 보유하여야 하며, 해당 자료 제출로 인하여
        제3자의 권리 침해 또는 분쟁이 발생하는 경우 그에 대한 책임은 이용자에게
        있습니다.
      </TermsText>
    </TermsSection>

    <TermsSection>
      <TermsSectionTitle>제11조 (자료의 제출 및 이용)</TermsSectionTitle>
      <TermsText>
        ① 이용자가 플랫폼을 통해 제출한 듀오 가입 입증 자료, 신분증 사본 기타
        자료는 참여 접수의 확인, 본인 및 가입 사실 확인, 사건 검토, 후속 절차
        안내, 소송 수행 준비 및 이에 부수하는 업무 처리를 위하여 필요한 범위
        내에서 이용될 수 있습니다.
      </TermsText>
      <TermsText>
        ② 회사는 이용자가 제출한 자료를 관계 법령, 개인정보 처리방침 및 별도
        동의 내용에 따라 보관·관리·열람할 수 있습니다.
      </TermsText>
      <TermsText>
        ③ 회사는 제출 자료가 서비스 목적에 명백히 부합하지 않거나, 제3자의
        권리를 침해하거나, 관련 법령에 위반된다고 판단하는 경우 해당 자료의
        접수를 거부하거나 삭제 또는 분리 보관 등의 조치를 할 수 있습니다.
      </TermsText>
    </TermsSection>

    <TermsSection>
      <TermsSectionTitle>제12조 (손해배상 및 면책)</TermsSectionTitle>
      <TermsText>
        ① 회사는 천재지변, 전쟁 등 회사가 합리적인 주의를 기울였음에도 통제할 수
        없는 사유로 서비스를 제공할 수 없는 경우 책임이 면제됩니다.
        본인확인기관·결제대행사 등 외부 사업자의 장애 또는 시스템 장애로 인하여
        서비스 제공이 일시 중단된 경우, 회사는 회복 및 안내를 위한 합리적 조치를
        취하며, 회사의 귀책사유가 없는 한 그로 인한 손해에 대하여 책임을 지지
        아니합니다.
      </TermsText>
      <TermsText>
        ② 이용자가 제공하는 정보 및 자료의 진실성, 정확성, 적법성은 원칙적으로
        이용자의 책임이며, 허위·부정확·위법한 정보 또는 자료로 인해 발생한
        문제에 대하여 회사는 회사의 귀책사유가 없는 한 책임을 지지 않습니다.
      </TermsText>
      <TermsText>
        ③ 회사는 참여 접수의 수리 여부, 소송위임계약 체결 여부, 소송 제기 여부
        또는 소송의 결과를 보장하지 않으며, 사건의 진행 및 결과는 사실관계,
        증거, 상대방 대응, 법원의 판단 등 여러 사정에 따라 달라질 수 있습니다.
      </TermsText>
      <TermsText>
        ④ 회사의 플랫폼에 게시된 모든 자료는 이용자들에게 일반적인 법률 정보를
        제공하기 위해 제작되었으므로, 개별적인 사안에 대해서는 반드시 법률
        전문가의 구체적인 조언이나 자문을 받으셔야 합니다.
      </TermsText>
      <TermsText>
        해당 전문가의 조언이나 자문을 받지 않은 채 본 웹사이트에 게재된 정보
        또는 타인이 제안한 사건 내용 등을 근거로 어떠한 행위를 하거나 하지
        아니함으로써 발생되는 결과에 대하여, 법무법인 더 에이치 황해는 어떠한
        법적 책임도 지지 아니한다는 점을 유념하시기 바랍니다.
      </TermsText>
      <TermsText>
        ⑤ 본 조는 회사의 고의 또는 중대한 과실로 인한 손해에 대한 책임까지
        배제하는 것으로 해석되지 않습니다.
      </TermsText>
    </TermsSection>

    <TermsSection>
      <TermsSectionTitle>제13조 (저작권)</TermsSectionTitle>
      <TermsText>
        ① 회사가 플랫폼에서 제공하는 저작물(문서 양식, 텍스트, 이미지, 로고
        등)에 관한 권리는 회사 또는 정당한 권리자에게 귀속됩니다.
      </TermsText>
      <TermsText>
        ② 이용자는 회사의 사전 서면 동의 없이 이를 복제, 배포, 공중송신 또는
        전시할 수 없습니다.
      </TermsText>
    </TermsSection>

    <TermsSection>
      <TermsSectionTitle>제14조 (개인정보 처리)</TermsSectionTitle>
      <TermsText>
        ① 회사는 서비스 제공을 위하여 필요한 최소한의 개인정보를 수집하며, 수집
        항목, 이용 목적, 보유기간, 제3자 제공 여부, 처리 위탁 등 구체적인 사항은
        별도의 개인정보 처리방침에 따릅니다.
      </TermsText>
      <TermsText>
        ② 주민등록번호, 신분증 사본 등 「개인정보 보호법」 제24조에 따른
        고유식별정보 및 같은 법 제24조의2에 따른 주민등록번호의 처리는 본인확인
        및 소송 당사자 특정을 위하여 필요한 범위에 한하며, 별도의 동의 절차에
        따라 처리합니다.
      </TermsText>
      <TermsText>
        ③ 회사는 개인정보 처리방침 및 관계 법령이 정하는 범위 내에서 개인정보를
        보관·관리하며, 보유기간 경과 또는 목적 달성 시 안전하게 파기합니다.
      </TermsText>
    </TermsSection>

    <TermsSection>
      <TermsSectionTitle>제15조 (공지 및 통지)</TermsSectionTitle>
      <TermsText>
        ① 회사는 서비스 운영과 관련된 주요 사항을 플랫폼 내 공지사항, 연결 화면
        또는 기타 적절한 방법으로 사전에 공지합니다. 다만 부득이한 사정으로 사전
        공지가 어려운 경우 사후 지체 없이 공지합니다.
      </TermsText>
      <TermsText>
        ② 회사와 이용자 간 통지는 플랫폼 내 공지, 전자우편, 문자메시지, 카카오
        알림톡, 전화, 기타 회사가 정한 방법으로 할 수 있습니다.
      </TermsText>
    </TermsSection>

    <TermsSection>
      <TermsSectionTitle>제16조 (회사 정보 및 문의처)</TermsSectionTitle>
      <TermsText>① 회사의 정보는 다음과 같습니다.</TermsText>
      <TermsList>
        <li>상호 : 법무법인 더 에이치 황해</li>
        <li>대표변호사 : 천 상 현</li>
        <li>
          주소 : 인천광역시 미추홀구 학익소로 60, 제1층 (학익동, 반도빌딩)
        </li>
      </TermsList>
      <TermsText>
        ② 서비스 이용, 참여 접수, 철회, 결제, 환불 기타 문의는 플랫폼에 기재된
        고객문의 채널 또는 회사가 별도로 안내하는 방법으로 할 수 있습니다.
      </TermsText>
    </TermsSection>

    <TermsSection>
      <TermsSectionTitle>제17조 (분쟁의 해결)</TermsSectionTitle>
      <TermsText>
        ① 본 약관의 해석과 적용에 관하여는 대한민국 법을 준거법으로 합니다.
      </TermsText>
      <TermsText>
        ② 서비스 이용과 관련하여 회사와 이용자 간 분쟁이 발생한 경우,
        인천지방법원 또는 이용자의 주소지를 관할하는 법원 중 어느 한 곳을
        합의관할 법원으로 합니다.
      </TermsText>
    </TermsSection>

    <TermsSection>
      <TermsSectionTitle>제18조 (시행일)</TermsSectionTitle>
      <TermsText>
        ① 회사는 본 이용약관을 개정하는 경우 시행일 및 주요 변경사항을 서비스 내
        공지 또는 홈페이지에 공지합니다.
      </TermsText>
      <TermsText>② 공고일자: [2026. 04. 27.]</TermsText>
      <TermsText>③ 시행일자: [2026. 04. 27.]</TermsText>
    </TermsSection>
  </TermsContentContainer>
);

// 개인정보 처리방침 JSX 컴포넌트
const PrivacyContent = () => (
  <PrivacyContentContainer>
    <PrivacyIntro>
      「결혼정보업체 듀오 개인정보 유출 피해 집단소송 참여 접수」 개인정보
      처리방침
      <br />
      법무법인 더 에이치 황해(이하 "회사")는 「개인정보 보호법」 제30조에 따라
      정보주체의 개인정보를 적법하게 처리하고 안전하게 관리하기 위하여 본
      개인정보 처리방침을 수립·공개합니다.
    </PrivacyIntro>

    <PrivacySection>
      <PrivacySectionTitle>제1조 (개인정보의 처리 목적)</PrivacySectionTitle>
      <PrivacyText>
        회사는 다음 각 호의 목적을 위하여 개인정보를 처리합니다. 처리한
        개인정보는 다음 목적 이외의 용도로 이용되지 않으며, 목적이 변경되는
        경우에는 필요한 경우 정보주체의 동의를 받는 등 「개인정보 보호법」
        제18조에 따른 필요한 조치를 이행합니다.
      </PrivacyText>
      <PrivacyList>
        <li>
          참여 접수 및 본인확인: 집단소송 참여 접수 처리, 본인확인, 듀오 가입
          사실 및 가입 내역 확인, 중복 접수 방지, 부정이용 방지, 고객지원
        </li>
        <li>
          서비스 제공 및 운영: 참여 접수 처리, 대상자 여부 검토, 추가 자료 제출
          요청 및 접수, 진행상황 안내, 서비스 관련 공지, 문의 응대
        </li>
        <li>
          소송위임계약 체결 및 본인확인 절차 진행: 소송위임계약서 및 관련 문서
          제공, 계약 체결 의사 확인, 계약 단계 본인확인, 관련 검증 및 확인 절차
          운영
        </li>
        <li>
          전자서명 절차 진행: 전자적 자필 서명 수집, 전자서명 이미지 사용 및
          활용 동의 확인, 전자적 인장 사용 동의 확인, 전자서명 관련 동의 절차
          운영
        </li>
        <li>
          결제 및 환불: 결제 처리, 환불 처리, 영수증 발급, 결제 관련 고객문의
          처리
        </li>
        <li>
          소송 수행 준비 및 관련 업무 처리: 제출 자료 검토, 듀오 가입 사실 및
          가입 내역 확인, 사건 관리, 소송 수행 준비, 분쟁 조정절차 대응, 소장
          작성·접수, 판결금 또는 정산금 지급 관련 처리, 관련 안내 및 고지
        </li>
      </PrivacyList>
    </PrivacySection>

    <PrivacySection>
      <PrivacySectionTitle>
        제2조 (개인정보의 수집 및 처리 항목)
      </PrivacySectionTitle>
      <PrivacyText>
        ① 회사는 서비스 제공에 필요한 최소한의 개인정보를 수집·처리합니다.
      </PrivacyText>
      <PrivacyText>
        ② 회사가 처리하는 개인정보 항목은 다음 각 호와 같습니다.
      </PrivacyText>
      <PrivacyList>
        <li>필수항목(참여 접수): 성명, 생년월일, 주소, 휴대전화번호</li>
        <li>
          듀오 가입 입증 관련 항목: 듀오 서비스 가입 유형(무료회원/유료회원
          구분), 가입비용, 대략적인 가입일자, 가입 안내문, 결제 내역, 화면 캡처,
          이메일, 문자, 그 밖에 가입 사실 및 가입 내역을 입증하거나 확인할 수
          있는 자료 일체
        </li>
        <li>
          소송위임계약 체결, 본인확인 및 사건 수행 관련 정보: 위 1호 및 4호의
          항목 외에 계좌정보(은행명, 계좌번호, 예금주명), 계약 체결 여부, 계약서
          확인 이력, 본인확인 결과, 계약 체결 및 사건 수행을 위한 검증·확인 정보
        </li>
        <li>고유식별정보(별도 동의): 주민등록번호(13자리), 신분증 사본</li>
        <li>
          전자서명 관련 정보: 전자적 자필 서명 이미지, 전자적 인장, 전자서명
          이미지 사용 및 활용 동의 여부, 서명 시각, 접속기록, 관련 인증 또는
          확인 정보
        </li>
        <li>
          결제·환불 관련 정보: 결제 승인정보(결제금액, 결제일시, 승인번호 등),
          영수증 발급에 필요한 정보, 환불 처리 정보, 전자결제 처리에 필요한
          연락처 정보(이메일 등)
        </li>
        <li>
          서비스 이용 과정에서 자동 생성되는 정보: IP Address, 쿠키, 접속기록,
          방문일시, 서비스 이용기록, 기기정보(브라우저/OS 등), 오류기록
        </li>
      </PrivacyList>
      <PrivacyText>③ 개인정보 수집 방법은 다음 각 호와 같습니다.</PrivacyText>
      <PrivacyList>
        <li>
          참여 접수, 자료 제출, 계약 체결 과정에서 이용자가 직접 입력하거나
          업로드하는 방법
        </li>
        <li>
          본인확인 과정에서 본인확인기관 또는 대행사를 통한 수집 또는 확인
        </li>
        <li>
          결제·환불 처리 과정에서 결제대행사(PG) 등을 통해 생성·수집되는 방법
        </li>
        <li>서비스 이용 과정에서 자동 생성·수집되는 방법(접속 로그 등)</li>
      </PrivacyList>
      <PrivacyText>
        ④ 회사는 「개인정보 보호법」 제24조에 따른 고유식별정보 및 같은 법
        제24조의2에 따른 주민등록번호를 본인확인 및 소송 당사자 특정을 위하여
        필요한 범위에서 정보주체로부터 별도의 동의를 받아 처리합니다. 본인인증
        단계에서는 주민등록번호가 본인확인기관을 통하여 처리되고 회사는 본인확인
        결과(CI/DI 등)만을 수신·관리하며, 그 외에 신분증 사본에 포함되어
        수집·보관되는 주민등록번호는 「민사소송법」, 「민사집행법」 등 관계
        법령에서 정한 본인 특정·소송 수행에 필요한 범위에서 처리되며, 안전한
        보관을 위하여 암호화하여 저장합니다.
      </PrivacyText>
      <PrivacyText>
        ⑤ 본 서비스는 원칙적으로 제3자의 개인정보 입력·업로드를 전제로 하지
        않습니다. 다만 이용자가 서비스 이용 과정에서 부득이하게 제3자의
        개인정보가 포함된 자료를 제출하는 경우, 이용자는 해당 정보의
        최소화·비식별화(마스킹)를 우선하여야 하며, 회사는 서비스 제공 목적 범위
        내에서만 이를 처리합니다.
      </PrivacyText>
      <PrivacyText>
        ⑥ 회사는 원칙적으로 민감정보를 수집하지 않습니다. 다만 이용자가 제출하는
        자료에 민감정보가 포함되는 경우, 회사는 서비스 제공 목적 범위 내에서
        최소한으로 처리하며 관련 법령에 따라 보호조치를 취합니다.
      </PrivacyText>
      <PrivacyText>
        ⑦ 회사는 만 19세 미만 미성년자의 개인정보를 수집하지 아니하며, 만 14세
        미만 아동의 개인정보 또한 수집하지 아니합니다.
      </PrivacyText>
    </PrivacySection>

    <PrivacySection>
      <PrivacySectionTitle>
        제3조 (개인정보의 처리 및 보유기간)
      </PrivacySectionTitle>
      <PrivacyText>
        ① 회사는 개인정보를 처리 목적 달성 시까지 보유·이용하며, 목적 달성 후
        지체 없이 파기합니다. 다만 관계 법령에 따라 일정 기간 보관이 필요한 경우
        해당 기간 동안 최소한의 범위에서 보관합니다.
      </PrivacyText>
      <PrivacyText>
        ② 회사의 주요 개인정보 보유기간은 다음 각 호와 같습니다.
      </PrivacyText>
      <PrivacyList>
        <li>
          참여 접수 정보 및 제출 자료: 참여 접수가 철회된 경우 즉시 파기하며,
          소송위임계약 체결로 이어진 경우 통상 소송 종료 후 5년까지 보관(다만,
          관계 법령에 따른 별도의 보관의무가 있는 경우 해당 기간까지)
        </li>
        <li>
          소송위임계약, 본인확인 및 전자서명 관련 정보: 계약관계 존속 중 및 관련
          법령상 보관기간 또는 분쟁 해결에 필요한 기간까지(통상 소송 종료 후
          5년)
        </li>
        <li>
          신분증 사본(신분증에 포함된 주민등록번호를 포함합니다) 및 본인확인
          결과 정보(CI/DI 등): 본인확인 및 소송 당사자 특정 목적 달성
          시까지(통상 소송 종료 후 5년)
        </li>
        <li>
          서비스 이용기록(로그 등): 3개월(통신비밀보호법 등 관계 법령에 따른
          보관)
        </li>
        <li>
          전자상거래 등 소비자보호 관련 보관(결제가 수반되는 경우)
          {"\n"}가. 표시·광고에 관한 기록: 6개월
          {"\n"}나. 계약 또는 청약철회 등에 관한 기록: 5년
          {"\n"}다. 대금결제 및 재화 등의 공급에 관한 기록: 5년
          {"\n"}라. 소비자 불만 또는 분쟁처리에 관한 기록: 3년
        </li>
      </PrivacyList>
    </PrivacySection>

    <PrivacySection>
      <PrivacySectionTitle>
        제4조 (개인정보의 제3자 제공에 관한 사항)
      </PrivacySectionTitle>
      <PrivacyText>
        ① 회사는 수집한 개인정보를 제1조의 목적 범위 내에서만 처리하며,
        원칙적으로 정보주체의 개인정보를 제3자에게 제공하지 않습니다. 다만 다음
        각 호의 경우에는 예외로 합니다.
      </PrivacyText>
      <PrivacyList>
        <li>정보주체가 사전에 동의한 경우</li>
        <li>
          법령에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여 불가피한
          경우
        </li>
        <li>
          회사의 서비스 이행 또는 소송 수행을 위하여 본 조 제2항에서 정한 자에
          한하여 개인정보를 제공하는 경우
        </li>
      </PrivacyList>
      <PrivacyText>
        ② 회사가 서비스 이행 및 소송 수행을 위하여 개인정보를 제공하는 내역은
        다음과 같습니다.
      </PrivacyText>
      <PrivacyTableWrapper>
        <PrivacyTable>
          <thead>
            <tr>
              <th>구분</th>
              <th>제공받는 자</th>
              <th>제공 목적</th>
              <th>제공 정보</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>본인확인</td>
              <td>(주)링크허브</td>
              <td>카카오 본인인증 처리</td>
              <td>성명, 휴대전화번호, 생년월일</td>
            </tr>
            <tr>
              <td>전자결제</td>
              <td>주식회사 코리아포트원</td>
              <td>전자결제 처리</td>
              <td>성명, 휴대전화번호, 이메일, 결제금액</td>
            </tr>
            <tr>
              <td>문자 및 알림톡 발송</td>
              <td>솔라피(주)</td>
              <td>문자 및 알림톡 발송</td>
              <td>성명, 휴대전화번호, 문자 및 알림톡 발송내용</td>
            </tr>
            <tr>
              <td>소송 수행을 위한 제공</td>
              <td>
                법원, 듀오정보 주식회사(피고), 소송 수행을 위하여 필요한
                감정인·전문가, 개인정보보호위원회 등 관련 행정기관
              </td>
              <td>
                소송 제기·수행, 소송 절차상 필요한 자료 제출, 사건 처리에
                부수하는 행정처리
              </td>
              <td>
                소송 수행에 필요한 범위 내의 신원정보, 주민등록번호 등
                고유식별정보, 연락처, 계좌정보, 듀오 가입 입증 자료, 신분증
                사본, 전자서명 자료 등
              </td>
            </tr>
          </tbody>
        </PrivacyTable>
      </PrivacyTableWrapper>
    </PrivacySection>

    <PrivacySection>
      <PrivacySectionTitle>
        제5조 (개인정보 처리업무의 위탁)
      </PrivacySectionTitle>
      <PrivacyText>
        ① 회사는 원활한 서비스 제공을 위하여 개인정보 처리업무를 위탁할 수
        있으며, 위탁 시 「개인정보 보호법」 제26조에 따른 사항을 계약서 등
        문서로 명확히 하고 수탁자가 개인정보를 안전하게 처리하도록
        관리·감독합니다.
      </PrivacyText>
      <PrivacyText>
        ② 회사의 국내 위탁 현황은 다음 각 호와 같습니다.
      </PrivacyText>
      <PrivacyTableWrapper>
        <PrivacyTable>
          <thead>
            <tr>
              <th>수탁자</th>
              <th>위탁업무</th>
              <th>위탁항목</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>AI Consilium Co., Ltd</td>
              <td>시스템 운영, 데이터베이스(DB) 관리, 서버 운영 및 유지보수</td>
              <td>서비스 운영에 필요한 범위의 개인정보 및 로그</td>
            </tr>
          </tbody>
        </PrivacyTable>
      </PrivacyTableWrapper>
      <PrivacyText>
        ③ 외부 수탁자는 시스템 운영 등 회사가 위탁한 업무에 한하여 관여하며,
        법률 자문·상담 기타 법률사무에는 일체 관여하지 아니합니다.
      </PrivacyText>
      <PrivacyText>
        ④ 회사는 위탁업무의 내용과 수탁자를 서비스 내 공지 또는 홈페이지를 통해
        지속적으로 공개합니다.
      </PrivacyText>
    </PrivacySection>

    <PrivacySection>
      <PrivacySectionTitle>
        제6조 (정보주체의 권리·의무 및 행사방법)
      </PrivacySectionTitle>
      <PrivacyText>
        ① 정보주체는 회사에 대해 언제든지 다음 각 호의 권리를 행사할 수
        있습니다.
      </PrivacyText>
      <PrivacyList>
        <li>개인정보 열람 요구</li>
        <li>개인정보 정정·삭제 요구</li>
        <li>개인정보 처리정지 요구</li>
        <li>동의 철회 요구</li>
      </PrivacyList>
      <PrivacyText>
        ② 정보주체는 이메일, 서면, 고객문의 채널 등을 통해 권리를 행사할 수
        있으며, 회사는 본인 확인 후 지체 없이 조치합니다.
      </PrivacyText>
      <PrivacyText>
        ③ 정보주체는 법정대리인 또는 위임을 받은 자를 통해 권리를 행사할 수
        있으며, 이 경우 위임장 등 증빙서류를 요구할 수 있습니다.
      </PrivacyText>
      <PrivacyText>
        ④ 관련 법령(「개인정보 보호법」 제35조 제4항·제36조 제1항 단서·제37조
        제2항 등)에 따라 열람·정정·삭제·처리정지 또는 동의 철회가 제한될 수
        있습니다. 특히 소송위임계약이 체결된 이후 소송 수행에 필요한 정보의
        처리정지 또는 동의 철회는 제한될 수 있으며, 이 경우 회사는 그 사유를
        정보주체에게 안내합니다.
      </PrivacyText>
    </PrivacySection>

    <PrivacySection>
      <PrivacySectionTitle>
        제7조 (개인정보의 파기 절차 및 방법)
      </PrivacySectionTitle>
      <PrivacyText>
        ① 회사는 개인정보 보유기간의 경과, 처리 목적 달성 등 파기사유가 발생한
        경우 지체 없이 해당 개인정보를 파기합니다.
      </PrivacyText>
      <PrivacyText>
        ② 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른
        법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를
        별도의 데이터베이스로 옮기거나 보관장소를 달리하여 보존할 수 있습니다.
      </PrivacyText>
      <PrivacyText>③ 파기절차는 다음 각 호와 같습니다.</PrivacyText>
      <PrivacyList>
        <li>파기사유 발생</li>
        <li>내부 승인(개인정보 보호책임자 또는 담당부서 관리)</li>
        <li>파기</li>
      </PrivacyList>
      <PrivacyText>④ 파기방법은 다음 각 호와 같습니다.</PrivacyText>
      <PrivacyList>
        <li>전자적 파일: 복구·재생이 불가능한 방법으로 삭제</li>
        <li>종이 문서: 분쇄 또는 소각</li>
      </PrivacyList>
    </PrivacySection>

    <PrivacySection>
      <PrivacySectionTitle>
        제8조 (개인정보의 안전성 확보조치)
      </PrivacySectionTitle>
      <PrivacyText>
        ① 회사는 개인정보의 안전성 확보를 위해 다음 각 호의 조치를 취합니다.
      </PrivacyText>
      <PrivacyList>
        <li>관리적 조치: 내부관리계획 수립·시행, 정기 교육, 접근권한 관리</li>
        <li>
          기술적 조치: 접근통제, 계정·권한 관리, 접속기록 보관 및 위·변조 방지,
          고유식별정보·결제정보·전자서명 이미지·신분증 사본 등의 암호화 저장,
          보안프로그램 운영
        </li>
        <li>물리적 조치: 전산실·자료보관실 접근통제 등</li>
      </PrivacyList>
    </PrivacySection>

    <PrivacySection>
      <PrivacySectionTitle>제9조 (개인정보 보호책임자)</PrivacySectionTitle>
      <PrivacyText>
        ① 회사는 개인정보 처리에 관한 업무를 총괄하여 책임지고, 개인정보 관련
        고충처리 및 피해구제를 위하여 다음과 같이 개인정보 보호책임자를
        지정합니다.
      </PrivacyText>
      <PrivacyContactInfo>
        성명: 천 상 현
        <br />
        직책: 변호사 / 개인정보 보호책임자
        <br />
        전화번호: 032-251-1000
        <br />
        이메일: theh1000@lfthe-h.com
      </PrivacyContactInfo>
    </PrivacySection>

    <PrivacySection>
      <PrivacySectionTitle>
        제10조 (쿠키의 설치·운영 및 거부방법)
      </PrivacySectionTitle>
      <PrivacyText>
        ① 회사는 서비스 제공을 위해 쿠키를 사용할 수 있습니다. 이용자는 브라우저
        설정을 통해 쿠키 저장을 거부하거나 삭제할 수 있습니다. 다만 쿠키 저장을
        거부할 경우 일부 서비스 이용에 어려움이 있을 수 있습니다.
      </PrivacyText>
      <PrivacyText>② 쿠키 설정 방법(예시)은 다음 각 호와 같습니다.</PrivacyText>
      <PrivacyList>
        <li>Chrome: 설정 → 개인정보 및 보안 → 쿠키 및 기타 사이트 데이터</li>
        <li>Edge: 설정 → 쿠키 및 사이트 권한 → 쿠키 및 사이트 데이터</li>
        <li>
          Safari: 설정 → 개인정보 보호 → 쿠키 및 웹사이트 데이터 관련 설정
        </li>
      </PrivacyList>
    </PrivacySection>

    <PrivacySection>
      <PrivacySectionTitle>제11조 (권익침해 구제방법)</PrivacySectionTitle>
      <PrivacyText>
        ① 정보주체는 개인정보 침해에 대한 신고·상담이 필요할 경우 아래 기관에
        문의할 수 있습니다.
      </PrivacyText>
      <PrivacyList>
        <li>개인정보침해신고센터: 국번 없이 118</li>
        <li>개인정보분쟁조정위원회: 1833-6972</li>
        <li>대검찰청 사이버수사 관련 부서: 국번 없이 1301</li>
        <li>경찰청 사이버수사국: 국번 없이 182</li>
      </PrivacyList>
      <PrivacyText>
        ② 위 기관은 회사와는 별개의 기관이며, 회사의 자체적인 개인정보 불만처리
        또는 피해구제 결과에 만족하지 못하거나 보다 자세한 도움이 필요한 경우
        문의할 수 있습니다.
      </PrivacyText>
    </PrivacySection>

    <PrivacySection>
      <PrivacySectionTitle>
        제12조 (개인정보 처리방침의 변경)
      </PrivacySectionTitle>
      <PrivacyText>
        ① 회사는 본 처리방침을 개정하는 경우 시행일 및 주요 변경사항을 서비스 내
        공지 또는 홈페이지에 공지합니다.
      </PrivacyText>
      <PrivacyText>② 공고일자: [2026. 04. 27.]</PrivacyText>
      <PrivacyText>③ 시행일자: [2026. 04. 27.]</PrivacyText>
    </PrivacySection>
  </PrivacyContentContainer>
);

// 마케팅 수신 동의 JSX 컴포넌트
const MarketingContent = () => (
  <MarketingContentContainer>
    <MarketingIntro>
      마케팅 수신 동의
      <br />
      법무법인 더 에이치 황해(이하 "법인")은 「정보통신망 이용촉진 및 정보보호
      등에 관한 법률」, 「개인정보보호법」 등 관련 법령에 따라 광고성 정보
      전송을 위해 사전 동의를 받고 있습니다. 동의하지 않으시더라도 서비스
      이용에는 제한이 없으나, 법인이 제공하는 혜택·소식·이벤트 등의 안내를 받기
      어려울 수 있습니다.
    </MarketingIntro>

    <MarketingSection>
      <MarketingSectionTitle>1. 수집·이용 목적</MarketingSectionTitle>
      <MarketingText>
        문자메시지, 알림톡 등을 통한 광고성 정보 및 이벤트 안내
      </MarketingText>
      <MarketingText>
        법무법인 더 에이치 황해의 서비스 소개, 소식, 혜택, 행사 등 마케팅 활용
      </MarketingText>
      <MarketingText>
        단, 소송 진행 및 법률 서비스 제공을 위한 필수 안내는 동의 여부와
        무관하게 제공됩니다.
      </MarketingText>
    </MarketingSection>

    <MarketingSection>
      <MarketingSectionTitle>2. 수집·이용 항목</MarketingSectionTitle>
      <MarketingText>휴대전화번호</MarketingText>
    </MarketingSection>

    <MarketingSection>
      <MarketingSectionTitle>3. 보유·이용 기간</MarketingSectionTitle>
      <MarketingText>
        동의일로부터 동의 철회 또는 서비스 탈퇴 시까지
      </MarketingText>
    </MarketingSection>

    <MarketingSection>
      <MarketingSectionTitle>4. 안내사항</MarketingSectionTitle>
      <MarketingText>
        본 동의는 선택 사항이며, 미동의 시에도 서비스 이용에는 제한이 없습니다.
      </MarketingText>
      <MarketingText>
        수신 동의 또는 철회는 언제든지 고객지원 채널을 통해 변경할 수 있습니다.
      </MarketingText>
    </MarketingSection>
  </MarketingContentContainer>
);

const IdentityVerificationInputPage = () => {
  const { navigateTo } = useContext(DirectionContext);
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [birthDateFront, setBirthDateFront] = useState(""); // 주민번호 앞 6자리
  const [birthDateBack, setBirthDateBack] = useState(""); // 주민번호 뒷 7자리
  const [residentNumberError, setResidentNumberError] = useState(""); // 주민번호 뒷자리 에러 메시지
  const [authMethod, setAuthMethod] = useState(KAKAO_AUTH_METHOD);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [isPolling, setIsPolling] = useState(false);
  const [showAgreementModal, setShowAgreementModal] = useState(false);
  const [agreements, setAgreements] = useState({
    terms: false,
    privacy: false,
    marketing: false,
  });
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const [showMarketingModal, setShowMarketingModal] = useState(false);
  const [showMismatchModal, setShowMismatchModal] = useState(false);
  const [showAlreadyCompletedModal, setShowAlreadyCompletedModal] =
    useState(false);

  // 외국인 알림을 위한 별도의 토스트 상태
  const [showToast2, setShowToast2] = useState(false);
  const [toastMessage2, setToastMessage2] = useState("");

  // ref 추가
  const birthDateRef = useRef(null);
  const birthDateBackRef = useRef(null); // 주민번호 뒷자리 ref
  const pollingIntervalRef = useRef(null);
  const pollingCountRef = useRef(0); // 폴링 횟수 추적

  // 페이지 로드 시 스크롤 위치를 맨 위로 초기화
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, []);

  // 컴포넌트 언마운트 시 폴링 정리
  useEffect(() => {
    return () => {
      stopStatusPolling();
    };
  }, []);

  // 폴링 모달이 열렸을 때 스크롤 잠금 (body + content-wrapper)
  useEffect(() => {
    if (!isPolling) return undefined;

    const html = document.documentElement;
    const body = document.body;
    const contentWrapper = document.querySelector(".content-wrapper");

    const previous = {
      htmlOverflow: html.style.overflow,
      bodyOverflow: body.style.overflow,
      bodyTouchAction: body.style.touchAction,
      wrapperOverflow: contentWrapper?.style.overflow ?? "",
      wrapperTouchAction: contentWrapper?.style.touchAction ?? "",
    };

    html.style.overflow = "hidden";
    body.style.overflow = "hidden";
    body.style.touchAction = "none";
    if (contentWrapper) {
      contentWrapper.style.overflow = "hidden";
      contentWrapper.style.touchAction = "none";
    }

    const preventTouchMove = (e) => {
      // 모달 내부 스크롤은 허용하기 위해 모달 안의 터치는 차단하지 않음
      if (e.target.closest("[data-polling-modal]")) return;
      e.preventDefault();
    };
    document.addEventListener("touchmove", preventTouchMove, {
      passive: false,
    });

    return () => {
      html.style.overflow = previous.htmlOverflow;
      body.style.overflow = previous.bodyOverflow;
      body.style.touchAction = previous.bodyTouchAction;
      if (contentWrapper) {
        contentWrapper.style.overflow = previous.wrapperOverflow;
        contentWrapper.style.touchAction = previous.wrapperTouchAction;
      }
      document.removeEventListener("touchmove", preventTouchMove);
    };
  }, [isPolling]);

  // 애니메이션 변수
  const pageVariants = {
    initial: {
      opacity: 0,
    },
    in: {
      opacity: 1,
      transition: {
        duration: 0.5,
      },
    },
    out: {
      opacity: 0,
      transition: {
        duration: 0.3,
      },
    },
  };

  const contentVariants = {
    initial: {
      opacity: 0,
      y: 20,
    },
    in: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        delay: 0.2,
        staggerChildren: 0.1,
      },
    },
  };

  // 외국인 알림 토스트 메시지 표시 함수
  const showForeignerToast = () => {
    setToastMessage2("외국인은 접수를 받지 않습니다");
    setShowToast2(true);
    setTimeout(() => {
      setShowToast2(false);
    }, 3000);
  };

  // 영어 문자 확인 함수
  const containsEnglish = (text) => {
    return /[a-zA-Z]/.test(text);
  };

  // 생년월일 유효성 검증 함수
  const validateBirthDate = (birthDateStr) => {
    if (birthDateStr.length !== 8) {
      return { isValid: false, message: "생년월일을 8자리로 입력해주세요" };
    }

    const year = parseInt(birthDateStr.substring(0, 4));
    const month = parseInt(birthDateStr.substring(4, 6));
    const day = parseInt(birthDateStr.substring(6, 8));

    // 연도 유효성 검증 (1900년 이후, 현재 연도 이하)
    const currentYear = new Date().getFullYear();
    if (year < 1900 || year > currentYear) {
      return { isValid: false, message: "올바른 생년월일을 입력해주세요" };
    }

    // 월 유효성 검증 (1-12)
    if (month < 1 || month > 12) {
      return { isValid: false, message: "올바른 생년월일을 입력해주세요" };
    }

    // 일 유효성 검증
    const daysInMonth = new Date(year, month, 0).getDate();
    if (day < 1 || day > daysInMonth) {
      return { isValid: false, message: "올바른 생년월일을 입력해주세요" };
    }

    // 미래 날짜 체크
    const birthDate = new Date(year, month - 1, day);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (birthDate > today) {
      return { isValid: false, message: "미래 날짜는 입력할 수 없습니다" };
    }

    // 미성년자 체크 (현재 연도 기준으로 19세 미만이면 접수 불가)
    const age = currentYear - year;
    // 생일이 지났는지 확인
    const currentMonth = new Date().getMonth() + 1;
    const currentDay = new Date().getDate();
    const actualAge =
      currentMonth > month || (currentMonth === month && currentDay >= day)
        ? age
        : age - 1;

    if (actualAge < 19) {
      return { isValid: false, message: "미성년자는 접수를 받지 않습니다" };
    }

    return { isValid: true, message: "" };
  };

  // 생년월일 입력 핸들러 (8자리만 입력)
  const handleBirthDateChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "").slice(0, 8);
    setBirthDate(value);

    // 8자리 입력되면 유효성 검증 및 주민번호 앞자리 자동 입력
    if (value.length === 8) {
      // 생년월일 유효성 검증
      const validation = validateBirthDate(value);

      if (!validation.isValid) {
        setToastMessage2(validation.message);
        setShowToast2(true);
        setTimeout(() => {
          setShowToast2(false);
        }, 3000);
        // 생년월일 초기화
        setBirthDate("");
        setBirthDateFront("");
        return;
      }

      // 유효한 생년월일이면 주민번호 앞자리 자동 입력 - 주석 처리 (주민등록번호 입력 필드 비활성화)
      // const frontPart = value.substring(2, 8); // YYYYMMDD에서 YYMMDD 추출
      // setBirthDateFront(frontPart);

      e.target.blur();
      // 주민번호 뒷자리 입력 필드로 포커스 이동 - 주석 처리 (주민등록번호 입력 필드 비활성화)
      // setTimeout(() => {
      //   if (birthDateBackRef.current) {
      //     birthDateBackRef.current.focus();
      //   }
      // }, 100);
    } else {
      // 생년월일이 8자리가 아니면 주민번호 앞자리 초기화
      setBirthDateFront("");
    }
  };

  // 휴대폰 번호 입력 핸들러
  const handlePhoneNumberChange = (e) => {
    const value = e.target.value.replace(/[^0-9]/g, "").slice(0, 11);
    setPhoneNumber(value);

    // 11자리 입력되면 생년월일 인풋으로 포커스 이동
    if (value.length === 11 && birthDateRef.current) {
      setTimeout(() => {
        birthDateRef.current?.focus();
      }, 100);
    }
  };

  // 이미 신청 완료 모달 확인 핸들러
  const handleAlreadyCompletedConfirm = () => {
    setShowAlreadyCompletedModal(false);
    // 토큰 삭제
    Cookies.remove(API_ENDPOINTS.COOKIE_CONFIG.KEYS.ACCESS_TOKEN);
    navigateTo("/select");
  };

  // 다음 버튼 활성화 여부 (카카오 인증 고정)
  const isNextButtonEnabled =
    name.trim() !== "" && phoneNumber.length === 11 && birthDate.length === 8;

  // 동의 모달에서 다음 버튼 활성화 여부
  const isAgreementNextEnabled = agreements.terms && agreements.privacy;

  // 동의 체크박스 토글
  const handleAgreementToggle = (key) => {
    setAgreements((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  // 동의 모달에서 다음 버튼 클릭
  const handleAgreementNext = () => {
    if (agreements.terms && agreements.privacy) {
      setShowAgreementModal(false);

      // 개인정보처리방침 / 이용약관 / 마케팅 수신 동의는 신청서 생성 전이므로
      // 로컬스토리지에 임시 저장 → 신청서 생성 후 PATCH /applications/{id} 로 반영
      saveInitialTermsToLocal({
        terms: agreements.terms,
        privacy: agreements.privacy,
        marketing: agreements.marketing,
      });

      // "인증이 불가해요" 선택한 경우
      if (authMethod && authMethod.value === "none") {
        // 쿠키에 데이터 저장
        Cookies.set("pendingVerificationName", name, { expires: 7, path: "/" });
        Cookies.set("pendingVerificationPhone", phoneNumber, {
          expires: 7,
          path: "/",
        });
        Cookies.set("pendingVerificationBirthDate", birthDate, {
          expires: 7,
          path: "/",
        });
        // 주민등록번호 앞자리와 뒷자리도 쿠키에 저장 - 주석 처리
        // Cookies.set("pendingVerificationBirthDateFront", birthDateFront, {
        //   expires: 7,
        //   path: "/",
        // });
        // Cookies.set("pendingVerificationBirthDateBack", birthDateBack, {
        //   expires: 7,
        //   path: "/",
        // });

        // /lawyer-verification으로 이동
        navigateTo("/lawyer-verification");
        return;
      }

      // 모든 경우에서 입력한 이름을 쿠키에 저장 (예금주명 검증용)
      Cookies.set("pendingVerificationName", name, { expires: 7, path: "/" });

      // 실제 본인인증 API 호출
      handleIdentityVerification();
    }
  };

  // 본인인증 API 호출
  const handleIdentityVerification = async () => {
    setIsLoading(true);
    setError("");

    try {
      // certificationType을 대문자로 변환 (KAKAO, NAVER, TOSS)
      const certificationType = authMethod.value.toUpperCase();

      // 1. 본인인증 요청
      const requestResponse = await fetch(
        `${API_ENDPOINTS.BASE_URL}/clients/request-identity`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            receiverHP: phoneNumber,
            receiverName: name,
            receiverBirthdate: birthDate,
            certificationType: certificationType,
            lawsuitId: 3,
          }),
        },
      );

      // 500 에러 체크
      if (requestResponse.status === 500) {
        setIsLoading(false);
        setShowMismatchModal(true);
        return;
      }

      const requestData = await requestResponse.json();

      if (!requestData.success || !requestData.receiptID) {
        throw new Error(requestData.message || "본인인증 요청에 실패했습니다.");
      }

      const receiptID = requestData.receiptID;

      // 2. 본인인증 상태 확인 폴링 시작
      startStatusPolling(receiptID, certificationType);
    } catch (error) {
      console.error("본인인증 오류:", error);
      setError(error.message || "본인인증 중 오류가 발생했습니다.");
      setIsLoading(false);
      stopStatusPolling();
    }
  };

  // 본인인증 상태 폴링 시작
  const startStatusPolling = (receiptID, certificationType) => {
    // 기존 폴링이 있으면 정지
    stopStatusPolling();

    // 상태 설정
    setIsLoading(true);
    setIsPolling(true);

    // 폴링 횟수 초기화
    pollingCountRef.current = 0;

    // 3초마다 본인인증 상태 확인
    pollingIntervalRef.current = setInterval(() => {
      checkIdentityVerificationStatus(receiptID, certificationType);
    }, 3000);

    // 첫 번째 확인 즉시 실행
    checkIdentityVerificationStatus(receiptID, certificationType);
  };

  // 본인인증 상태 폴링 중지
  const stopStatusPolling = () => {
    if (pollingIntervalRef.current) {
      clearInterval(pollingIntervalRef.current);
      pollingIntervalRef.current = null;
    }
    setIsPolling(false);
  };

  // 본인인증 상태 확인
  const checkIdentityVerificationStatus = async (
    receiptID,
    certificationType,
  ) => {
    // 폴링 횟수 증가
    pollingCountRef.current += 1;

    // 최대 30회 초과 시 폴링 중지
    if (pollingCountRef.current > 30) {
      stopStatusPolling();
      setIsLoading(false);
      setError("본인인증 확인 시간이 초과되었습니다. 다시 시도해주세요.");
      return;
    }

    try {
      const applicationType = Cookies.get("applicationType") || "self";
      const verifyResponse = await fetch(
        `${
          API_ENDPOINTS.BASE_URL
        }/clients/identity-status/${receiptID}?certificationType=${certificationType}&applicationType=${
          applicationType === "representative" ? "REPRESENTATIVE" : "INDIVIDUAL"
        }&lawsuitId=3`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (!verifyResponse.ok) {
        // 네트워크 오류 등의 일시적인 문제는 폴링 유지
        return;
      }

      const verifyData = await verifyResponse.json();

      if (!verifyData.success) {
        console.warn(
          "[진단] success=false → '/'로 리다이렉트 직전. message:",
          verifyData.message,
        );
        // 오류가 발생한 경우 폴링 중지
        stopStatusPolling();
        setIsLoading(false);
        setError(verifyData.message || "본인인증 확인 중 오류가 발생했습니다.");
        // "잘못된 접근입니다." 메시지일 때 쿼리 파라미터 추가
        if (verifyData.message === "잘못된 접근입니다.") {
          navigateTo("/?joint=true");
        } else {
          navigateTo("/");
        }
        return;
      }

      if (verifyData.isCompleted && verifyData.success) {
        if (!verifyData.token) {
          console.warn(
            "[진단] verifyData.token이 비어있음 → ProtectedRoute가 '/'로 보낼 가능성",
          );
        }
        // 본인인증 완료 - 토큰 저장 후 다음 페이지로 이동
        if (verifyData.token) {
          // 토큰을 쿠키에 저장
          Cookies.set(
            API_ENDPOINTS.COOKIE_CONFIG.KEYS.ACCESS_TOKEN,
            verifyData.token,
            {
              expires: API_ENDPOINTS.COOKIE_CONFIG.EXPIRES.ACCESS_TOKEN,
              ...API_ENDPOINTS.COOKIE_CONFIG.OPTIONS,
            },
          );
          const savedToken = Cookies.get(
            API_ENDPOINTS.COOKIE_CONFIG.KEYS.ACCESS_TOKEN,
          );

          // 휴대폰 번호를 숫자만 추출하여 쿠키에 저장 (NewsProofSubmission에서 검증에 사용)
          const normalizedPhone = String(phoneNumber).replace(/[^0-9]/g, "");
          Cookies.set("verifiedPhoneNumber", normalizedPhone, {
            expires: 7,
            ...API_ENDPOINTS.COOKIE_CONFIG.OPTIONS,
          });

          // 토큰 저장 후 /clients/me GET으로 신청 완료 여부 확인
          try {
            const getResponse = await fetch(
              `${API_ENDPOINTS.BASE_URL}/clients/me`,
              {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${verifyData.token}`,
                },
              },
            );

            if (getResponse.ok) {
              const userData = await getResponse.json();

              // 이미 집단소송 신청을 완료한 경우 확인 (applications 배열에서 확인)
              const hasCompletedApplication =
                userData.applications &&
                userData.applications.some(
                  (app) =>
                    app.lawsuitId === 3 && app.status === "PAYMENT_COMPLETED",
                );

              if (hasCompletedApplication) {
                // 이미 신청 완료한 경우 모달 표시
                stopStatusPolling();
                setIsLoading(false);
                setShowAlreadyCompletedModal(true);
                return;
              }
            }
          } catch (error) {
            console.error("사용자 정보 조회 중 오류:", error);
          }

          // 신청 완료하지 않은 경우에만 PATCH API 호출
          try {
            // PATCH 요청 body 구성 (백엔드에서 빠진 필드 제거 → 빈 body)
            const putBody = {};

            // /clients/me PATCH API 호출
            const putResponse = await fetch(
              `${API_ENDPOINTS.BASE_URL}/clients/me`,
              {
                method: "PATCH",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${verifyData.token}`,
                },
                body: JSON.stringify(putBody),
              },
            );

            if (!putResponse.ok) {
              console.error(
                "사용자 정보 업데이트 실패:",
                await putResponse.text(),
              );
            }
          } catch (error) {
            console.error("사용자 정보 업데이트 중 오류:", error);
          }
        }
        stopStatusPolling();
        setIsLoading(false);
        const tokenAtNav = Cookies.get(
          API_ENDPOINTS.COOKIE_CONFIG.KEYS.ACCESS_TOKEN,
        );

        navigateTo("/user-data");
      } else {
        // 본인인증이 아직 완료되지 않음 - 폴링 계속
        // 폴링 상태 유지 (isPolling은 이미 true)
      }
    } catch (error) {
      // 네트워크 오류 등의 일시적인 문제는 폴링 유지
      console.error("본인인증 상태 확인 오류:", error);
    }
  };

  return (
    <PageBackground>
      <AnimatePresence>
        {isPolling && (
          <PollingOverlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <PollingModal
              data-polling-modal
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
            >
              <Spinner />
              <PollingIndicatorText>
                {authMethod?.value === "naver"
                  ? "네이버 본인인증이 도착했습니다."
                  : authMethod?.value === "toss"
                    ? "토스 본인인증이 도착했습니다."
                    : "카카오톡 본인인증이 도착했습니다."}
                <br />
                {authMethod?.value === "naver"
                  ? "네이버에서 인증을 완료하고 돌아와주세요."
                  : authMethod?.value === "toss"
                    ? "토스에서 인증을 완료하고 돌아와주세요."
                    : "카카오톡에서 인증을 완료하고 돌아와주세요."}
              </PollingIndicatorText>
            </PollingModal>
          </PollingOverlay>
        )}
      </AnimatePresence>
      <Container
        variants={pageVariants}
        initial="initial"
        animate="in"
        exit="out"
      >
        <Content variants={contentVariants} initial="initial" animate="in">
          <Header>
            <SubTitle>본인인증 정보를 입력해주세요</SubTitle>
            <Description>본인인증에 필요한 내역을 작성해주세요</Description>
          </Header>

          {/* 안내문구 */}
          <InfoBox>
            <InfoIcon>ⓘ</InfoIcon>
            <InfoText>
              본 신청은 미성년자와 외국인은 접수받지 않습니다.
            </InfoText>
          </InfoBox>

          {/* 본인 인증 정보 입력 섹션 */}
          <VerificationSection>
            <SectionTitle>본인 인증 정보입력</SectionTitle>
            <FormGroup>
              <Label>
                이름<Required>*</Required>
              </Label>
              <Input
                type="text"
                placeholder="이름을 입력해주세요"
                value={name}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  setName(inputValue);

                  // 영어 문자가 포함되어 있으면 외국인으로 간주하고 토스트 표시
                  if (containsEnglish(inputValue)) {
                    showForeignerToast();
                    // 이름 초기화
                    setName("");
                  }
                }}
              />
            </FormGroup>

            <FormGroup>
              <Label>
                휴대폰 번호<Required>*</Required>
              </Label>
              <Input
                type="tel"
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder="휴대폰 번호를 입력해주세요"
                value={phoneNumber}
                onChange={handlePhoneNumberChange}
                isNumeric
              />
            </FormGroup>

            <FormGroup>
              <Label>
                생년월일<Required>*</Required>
              </Label>
              <Input
                ref={birthDateRef}
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder="생년월일을 입력해주세요 (YYYYMMDD)"
                value={birthDate}
                onChange={handleBirthDateChange}
                maxLength={8}
                isNumeric
              />
            </FormGroup>

            {/* 주민등록번호 입력 필드 - 주석 처리 */}
            {/* <FormGroup>
              <Label>
                주민등록번호<Required>*</Required>
              </Label>
              <ResidentNumberContainer>
                <ResidentNumberInput
                  type="text"
                  autoComplete="off"
                  placeholder="YYMMDD"
                  value={birthDateFront}
                  readOnly
                  style={{
                    backgroundColor: "#f5f5f5",
                    cursor: "not-allowed",
                  }}
                />
                <ResidentNumberInput
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  autoComplete="off"
                  placeholder="주민번호 뒷 7자리"
                  value={
                    birthDateBack.length === 0
                      ? ""
                      : birthDateBack.length === 7
                      ? "•••••••"
                      : birthDateBack.length === 1
                      ? birthDateBack
                      : "•".repeat(birthDateBack.length - 1) +
                        birthDateBack[birthDateBack.length - 1]
                  }
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    // 마스킹 문자(•)를 제거하고 숫자만 추출
                    const numericValue = inputValue
                      .replace(/[^0-9]/g, "")
                      .slice(0, 7);

                    // 이전 값과 비교하여 실제로 변경된 경우에만 업데이트
                    if (numericValue !== birthDateBack) {
                      setBirthDateBack(numericValue);

                      // 주민번호 뒷자리 첫 번째 자리 검증 (1, 2, 3, 4로 시작해야 함)
                      if (numericValue.length > 0) {
                        const firstDigit = numericValue[0];
                        if (!["1", "2", "3", "4"].includes(firstDigit)) {
                          setResidentNumberError(
                            "주민등록번호 뒷자리를 정확하게 입력해주세요."
                          );
                        } else {
                          setResidentNumberError("");
                        }
                      } else {
                        setResidentNumberError("");
                      }
                    }

                    // 7자리 입력 완료 시 키보드 닫기
                    if (numericValue.length === 7) {
                      setTimeout(() => {
                        birthDateBackRef.current?.blur();
                      }, 100);
                    }
                  }}
                  onKeyDown={(e) => {
                    // 숫자 키 입력 시 처리
                    if (/^[0-9]$/.test(e.key)) {
                      // 현재 값이 7자리 미만이면 입력 허용
                      if (birthDateBack.length < 7) {
                        const newValue = birthDateBack + e.key;
                        if (newValue.length <= 7) {
                          setBirthDateBack(newValue);

                          // 주민번호 뒷자리 첫 번째 자리 검증 (1, 2, 3, 4로 시작해야 함)
                          if (newValue.length === 1) {
                            if (!["1", "2", "3", "4"].includes(e.key)) {
                              setResidentNumberError(
                                "주민등록번호 뒷자리를 정확하게 입력해주세요."
                              );
                            } else {
                              setResidentNumberError("");
                            }
                          } else if (
                            newValue.length > 1 &&
                            birthDateBack.length === 0
                          ) {
                            // 첫 번째 자리가 이미 입력된 경우 재검증
                            const firstDigit = newValue[0];
                            if (!["1", "2", "3", "4"].includes(firstDigit)) {
                              setResidentNumberError(
                                "주민등록번호 뒷자리는 1, 2, 3, 4로 시작해야 합니다."
                              );
                            } else {
                              setResidentNumberError("");
                            }
                          }

                          e.preventDefault();
                          if (newValue.length === 7) {
                            setTimeout(() => {
                              birthDateBackRef.current?.blur();
                            }, 100);
                          }
                        }
                      } else {
                        e.preventDefault();
                      }
                    }
                    // 백스페이스 키 처리
                    else if (e.key === "Backspace") {
                      if (birthDateBack.length > 0) {
                        const newValue = birthDateBack.slice(0, -1);
                        setBirthDateBack(newValue);
                        // 첫 번째 자리가 삭제되면 에러 메시지도 제거
                        if (newValue.length === 0) {
                          setResidentNumberError("");
                        } else {
                          // 첫 번째 자리 재검증
                          const firstDigit = newValue[0];
                          if (!["1", "2", "3", "4"].includes(firstDigit)) {
                            setResidentNumberError(
                              "주민등록번호 뒷자리를 정확하게 입력해주세요."
                            );
                          } else {
                            setResidentNumberError("");
                          }
                        }
                      }
                    }
                    // Delete 키 처리
                    else if (e.key === "Delete") {
                      if (birthDateBack.length > 0) {
                        const newValue = birthDateBack.slice(0, -1);
                        setBirthDateBack(newValue);
                        // 첫 번째 자리가 삭제되면 에러 메시지도 제거
                        if (newValue.length === 0) {
                          setResidentNumberError("");
                        } else {
                          // 첫 번째 자리 재검증
                          const firstDigit = newValue[0];
                          if (!["1", "2", "3", "4"].includes(firstDigit)) {
                            setResidentNumberError(
                              "주민등록번호 뒷자리를 정확하게 입력해주세요."
                            );
                          } else {
                            setResidentNumberError("");
                          }
                        }
                      }
                    }
                    // 화살표 키, Tab 키는 허용
                    else if (
                      [
                        "ArrowLeft",
                        "ArrowRight",
                        "ArrowUp",
                        "ArrowDown",
                        "Tab",
                      ].includes(e.key)
                    ) {
                      // 허용
                    }
                    // Ctrl/Cmd + A, C, V 등은 허용
                    else if (e.ctrlKey || e.metaKey) {
                      // 허용
                    }
                    // 그 외의 키는 차단
                    else {
                      e.preventDefault();
                    }
                  }}
                  onPaste={(e) => {
                    e.preventDefault();
                    const pastedText = e.clipboardData.getData("text");
                    const numericValue = pastedText
                      .replace(/[^0-9]/g, "")
                      .slice(0, 7);
                    setBirthDateBack(numericValue);

                    // 주민번호 뒷자리 첫 번째 자리 검증 (1, 2, 3, 4로 시작해야 함)
                    if (numericValue.length > 0) {
                      const firstDigit = numericValue[0];
                      if (!["1", "2", "3", "4"].includes(firstDigit)) {
                        setResidentNumberError(
                          "주민등록번호 뒷자리를 정확하게 입력해주세요."
                        );
                      } else {
                        setResidentNumberError("");
                      }
                    } else {
                      setResidentNumberError("");
                    }

                    if (numericValue.length === 7) {
                      setTimeout(() => {
                        birthDateBackRef.current?.blur();
                      }, 100);
                    }
                  }}
                  maxLength={7}
                  ref={birthDateBackRef}
                />
              </ResidentNumberContainer>
              {residentNumberError && (
                <ResidentNumberErrorMessage>
                  {residentNumberError}
                </ResidentNumberErrorMessage>
              )}
            </FormGroup>
            <ResidentInfoBox>
              <ResidentInfoIcon>ⓘ</ResidentInfoIcon>
              <ResidentInfoText>
                해당 정보는 소송 인증에 필요한 정보입니다.
                <br />
                해당 정보는 암호화하여 철저히 관리합니다.
              </ResidentInfoText>
            </ResidentInfoBox>
            </FormGroup>
            */}
          </VerificationSection>

          {error && <ErrorMessage>{error}</ErrorMessage>}

          <ButtonsContainer>
            <KakaoAuthButton
              onClick={() => setShowAgreementModal(true)}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              disabled={!isNextButtonEnabled || isLoading}
            >
              {/* <KakaoAuthIcon src="/png/kakaoIcon.png" alt="카카오" /> */}
              카카오 인증하기
            </KakaoAuthButton>
          </ButtonsContainer>
        </Content>
      </Container>

      {/* 이용약관 동의 모달 */}
      <AnimatePresence>
        {showAgreementModal && (
          <AgreementModalOverlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowAgreementModal(false)}
          >
            <AgreementModalContainer
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
              onClick={(e) => e.stopPropagation()}
            >
              <AgreementModalTitle>서비스 약관</AgreementModalTitle>

              <AgreementModalContent>
                <AgreementItem onClick={() => handleAgreementToggle("terms")}>
                  <AgreementCheckbox>
                    {agreements.terms ? (
                      <CheckedIcon src="/png/checked.png" alt="체크됨" />
                    ) : (
                      <UncheckedIcon
                        src="/png/checkedinActive.png"
                        alt="체크 안됨"
                      />
                    )}
                  </AgreementCheckbox>
                  <AgreementText>
                    <RequiredBadge>[필수]</RequiredBadge> 이용약관에 동의합니다.
                  </AgreementText>
                  <ViewLink
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowTermsModal(true);
                    }}
                  >
                    보기
                  </ViewLink>
                </AgreementItem>

                <AgreementItem onClick={() => handleAgreementToggle("privacy")}>
                  <AgreementCheckbox>
                    {agreements.privacy ? (
                      <CheckedIcon src="/png/checked.png" alt="체크됨" />
                    ) : (
                      <UncheckedIcon
                        src="/png/checkedinActive.png"
                        alt="체크 안됨"
                      />
                    )}
                  </AgreementCheckbox>
                  <AgreementText>
                    <RequiredBadge>[필수]</RequiredBadge> 개인정보 처리방침에
                    동의합니다.
                  </AgreementText>
                  <ViewLink
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowPrivacyModal(true);
                    }}
                  >
                    보기
                  </ViewLink>
                </AgreementItem>

                <AgreementItem
                  onClick={() => handleAgreementToggle("marketing")}
                >
                  <AgreementCheckbox>
                    {agreements.marketing ? (
                      <CheckedIcon src="/png/checked.png" alt="체크됨" />
                    ) : (
                      <UncheckedIcon
                        src="/png/checkedinActive.png"
                        alt="체크 안됨"
                      />
                    )}
                  </AgreementCheckbox>
                  <AgreementText>
                    <OptionalBadge>[선택]</OptionalBadge> 마케팅 수신에
                    동의합니다.
                  </AgreementText>
                  <ViewLink
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowMarketingModal(true);
                    }}
                  >
                    보기
                  </ViewLink>
                </AgreementItem>
              </AgreementModalContent>

              <AgreementModalFooter>
                <AgreementNextButton
                  onClick={handleAgreementNext}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  disabled={!isAgreementNextEnabled}
                >
                  다음으로
                </AgreementNextButton>
              </AgreementModalFooter>
            </AgreementModalContainer>
          </AgreementModalOverlay>
        )}
      </AnimatePresence>

      {/* 이용약관 보기 모달 */}
      <AnimatePresence>
        {showTermsModal && (
          <TermsModalOverlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowTermsModal(false)}
          >
            <TermsModalContainer
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
              onClick={(e) => e.stopPropagation()}
            >
              <TermsModalHeader>
                <TermsModalTitle>이용약관</TermsModalTitle>
                <CloseButton onClick={() => setShowTermsModal(false)}>
                  ×
                </CloseButton>
              </TermsModalHeader>
              <TermsModalBody>
                <TermsContent />
              </TermsModalBody>
              <TermsModalFooter>
                <TermsConfirmButton
                  onClick={() => {
                    setAgreements((prev) => ({ ...prev, terms: true }));
                    setShowTermsModal(false);
                  }}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  확인
                </TermsConfirmButton>
              </TermsModalFooter>
            </TermsModalContainer>
          </TermsModalOverlay>
        )}
      </AnimatePresence>

      {/* 개인정보 처리방침 보기 모달 */}
      <AnimatePresence>
        {showPrivacyModal && (
          <TermsModalOverlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowPrivacyModal(false)}
          >
            <TermsModalContainer
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
              onClick={(e) => e.stopPropagation()}
            >
              <TermsModalHeader>
                <TermsModalTitle>개인정보 처리방침</TermsModalTitle>
                <CloseButton onClick={() => setShowPrivacyModal(false)}>
                  ×
                </CloseButton>
              </TermsModalHeader>
              <TermsModalBody>
                <PrivacyContent />
              </TermsModalBody>
              <TermsModalFooter>
                <TermsConfirmButton
                  onClick={() => {
                    setAgreements((prev) => ({ ...prev, privacy: true }));
                    setShowPrivacyModal(false);
                  }}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  확인
                </TermsConfirmButton>
              </TermsModalFooter>
            </TermsModalContainer>
          </TermsModalOverlay>
        )}
      </AnimatePresence>

      {/* 마케팅 수신 동의 보기 모달 */}
      <AnimatePresence>
        {showMarketingModal && (
          <TermsModalOverlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowMarketingModal(false)}
          >
            <TermsModalContainer
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
              onClick={(e) => e.stopPropagation()}
            >
              <TermsModalHeader>
                <TermsModalTitle>마케팅 수신 동의</TermsModalTitle>
                <CloseButton onClick={() => setShowMarketingModal(false)}>
                  ×
                </CloseButton>
              </TermsModalHeader>
              <TermsModalBody>
                <MarketingContent />
              </TermsModalBody>
              <TermsModalFooter>
                <TermsConfirmButton
                  onClick={() => {
                    setAgreements((prev) => ({ ...prev, marketing: true }));
                    setShowMarketingModal(false);
                  }}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  확인
                </TermsConfirmButton>
              </TermsModalFooter>
            </TermsModalContainer>
          </TermsModalOverlay>
        )}
      </AnimatePresence>

      {/* 이미 신청 완료 안내 모달 */}
      <AnimatePresence>
        {showAlreadyCompletedModal && (
          <CenterModalOverlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={handleAlreadyCompletedConfirm}
          >
            <CenterModalContainer
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ duration: 0.2 }}
              onClick={(e) => e.stopPropagation()}
            >
              <CenterModalTitle>
                이미 집단소송 신청을 완료하셨습니다.
              </CenterModalTitle>
              <CenterModalBody>
                <CenterModalText>
                  소송 진행 상황은 메인 페이지에서 확인하실 수 있습니다.
                </CenterModalText>
              </CenterModalBody>
              <CenterModalFooter>
                <CenterModalButton
                  onClick={handleAlreadyCompletedConfirm}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  확인
                </CenterModalButton>
              </CenterModalFooter>
            </CenterModalContainer>
          </CenterModalOverlay>
        )}
      </AnimatePresence>

      {/* 정보 불일치 모달 */}
      <AnimatePresence>
        {showMismatchModal && (
          <CenterModalOverlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowMismatchModal(false)}
          >
            <CenterModalContainer
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.9 }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
              onClick={(e) => e.stopPropagation()}
            >
              <CenterModalTitle>인증 실패</CenterModalTitle>
              <CenterModalBody>
                <CenterModalText>
                  {authMethod?.label || "선택된 인증수단"}에 등록된 정보와
                  일치하지 않습니다.
                </CenterModalText>
              </CenterModalBody>
              <CenterModalFooter>
                <CenterModalButton
                  onClick={() => setShowMismatchModal(false)}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  style={{ width: "100%" }}
                >
                  확인
                </CenterModalButton>
              </CenterModalFooter>
            </CenterModalContainer>
          </CenterModalOverlay>
        )}
      </AnimatePresence>

      {/* 외국인/미성년자 접수 불가 알림 */}
      <AnimatePresence>
        {showToast2 && (
          <Toast2
            variants={toast2Variants}
            initial="initial"
            animate="animate"
            exit="exit"
          >
            <AlertIcon>!</AlertIcon>
            {toastMessage2}
          </Toast2>
        )}
      </AnimatePresence>
    </PageBackground>
  );
};

// 스타일 컴포넌트
const PageBackground = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 0;
  background-color: #f7f7f7;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  @media (min-width: 769px) {
    padding: 40px 20px 60px;
    background-color: #f7f7f7;
  }
`;

const Container = styled(motion.div)`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: #f7f7f7;

  /* 모바일 디바이스 */
  @media (max-width: 768px) {
    min-height: auto;
    box-shadow: none;
    padding: 0 0 80px 0;
    max-width: 100%;
    margin: 0;
    border-radius: 0;
  }

  /* 데스크탑 디바이스 */
  @media (min-width: 769px) {
    border-radius: 20px;
    min-height: auto;
    max-height: none;
    max-width: 470px;
    margin: 0 auto;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    padding: 20px;
  }
`;

const Content = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  width: 100%;
  position: relative;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 60px 20px 80px;
  }

  @media (min-width: 769px) {
    padding: 40px 30px 40px 30px;
  }
`;

const Header = styled.div`
  width: 100%;
  margin-bottom: 20px;
  color: #333;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const SubTitle = styled.h2`
  font-size: 28px;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 10px;
  word-break: keep-all;
  color: #333;
  text-align: left;
  width: 100%;
`;

const Description = styled.p`
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
  line-height: 1.4;
`;

const InfoBox = styled.div`
  width: 100%;
  background-color: white;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  box-sizing: border-box;
`;

const ResidentInfoBox = styled.div`
  width: 100%;
  background-color: white;
  border-radius: 12px;
  padding: 0px 16px 0 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  box-sizing: border-box;

  /* VerificationSection 내부에 있을 때 패딩 상쇄 */
  margin-left: -24px;
  margin-right: -24px;
  width: calc(100% + 48px);
`;

const InfoIcon = styled.span`
  color: #e31c20;
  margin-top: 0px;
  font-size: 16px;
  margin-right: 0px;
  font-weight: bold;
  flex-shrink: 0;
`;

const InfoText = styled.p`
  font-size: 13px;
  color: #333;
  line-height: 1.5;
  margin: 0;
  flex: 1;
`;

const ResidentInfoIcon = styled.span`
  color: #e31c20;
  margin-top: 0px;
  font-size: 16px;
  margin-right: 0px;
  font-weight: bold;
  flex-shrink: 0;
`;

const ResidentInfoText = styled.p`
  font-size: 13px;
  color: #333;
  line-height: 1.5;
  margin: 0;
  flex: 1;
`;

const VerificationSection = styled.div`
  width: 100%;
  background-color: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  box-sizing: border-box;
`;

const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 700;
  color: #333;
  margin: 0 0 8px 0;
`;

const FormGroup = styled.div`
  width: 100%;
  margin-bottom: 0px;
`;

const Label = styled.label`
  display: block;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 8px;
  color: #2e3840;
`;

const Required = styled.span`
  color: #fe7156;
  margin-left: 2px;
`;

const Input = styled.input`
  flex: 1;
  height: 56px;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  padding: 0 16px;
  font-size: 16px;
  background-color: white;
  width: 100%;
  box-sizing: border-box;
  letter-spacing: ${(props) => (props.isNumeric ? "2px" : "normal")};

  &::placeholder {
    color: #999;
    letter-spacing: normal;
  }

  &:focus {
    border-color: #e31c20;
    outline: none;
  }
`;

const ResidentNumberContainer = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
`;

const ResidentNumberInput = styled.input`
  width: calc(50% - 4px);
  height: 56px;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  padding: 0 16px;
  font-size: 16px;
  background-color: white;
  box-sizing: border-box;
  letter-spacing: 6px;
  text-align: center;

  &:first-child {
    margin-right: 8px;
  }

  &::placeholder {
    color: #999;
    letter-spacing: normal;
  }

  &:focus {
    outline: none;
    border-color: #e31c20;
  }
`;

const ButtonsContainer = styled.div`
  max-width: 400px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-top: 0px;
  padding: 0 0px;
  background-color: #f7f7f7;
  margin: 0 auto;

  @media (min-width: 769px) {
    padding: 0;
    background-color: transparent;
    justify-content: center;
  }
`;

const KakaoAuthButton = styled(motion.button)`
  flex: 1;
  display: flex;
  height: 56px;
  padding: 0px 14px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 20px;
  background: ${(props) => (props.disabled ? "#FFF3B0" : "#FEE500")};
  color: ${(props) => (props.disabled ? "#999999" : "#191600")};
  font-size: 16px;
  font-weight: 600;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  border: none;
  opacity: 1;
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
`;

const KakaoAuthIcon = styled.img`
  width: 22px;
  height: 22px;
  object-fit: contain;
  flex-shrink: 0;
`;

const ErrorMessage = styled.div`
  width: 100%;
  padding: 12px 16px;
  margin-bottom: 20px;
  background-color: #fff5f5;
  border: 1px solid #ffcccc;
  border-radius: 8px;
  color: #d32f2f;
  font-size: 14px;
  text-align: center;
`;

const ResidentNumberErrorMessage = styled.div`
  width: 100%;
  padding: 12px 16px;
  margin-top: 8px;
  background-color: #fff5f5;
  border: 1px solid #ffcccc;
  border-radius: 8px;
  color: #d32f2f;
  font-size: 14px;
  text-align: left;
`;

const PollingOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
`;

const PollingModal = styled(motion.div)`
  background-color: white;
  border-radius: 16px;
  padding: 32px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  max-width: 400px;
  width: 100%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
`;

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #e3f2fd;
  border-top-color: #e31c20;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  flex-shrink: 0;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

const PollingIndicatorText = styled.div`
  font-size: 14px;
  color: #333;
  line-height: 1.6;
  text-align: center;
`;

// 이용약관 동의 모달 스타일
const AgreementModalOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 1000;
  touch-action: none;

  @media (min-width: 769px) {
    align-items: center;
  }
`;

const AgreementModalContainer = styled(motion.div)`
  width: 100%;
  max-width: 500px;
  background-color: white;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 80vh;

  @media (min-width: 769px) {
    border-radius: 16px;
    max-width: 420px;
    max-height: 90vh;
  }
`;

const AgreementModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  padding: 20px;
  margin: 0;
  text-align: center;
  border-bottom: 1px solid #eee;
`;

const AgreementModalContent = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 0;
  flex: 1;
  overflow-y: auto;
`;

const AgreementItem = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 0;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
`;

const AgreementCheckbox = styled.div`
  width: 24px;
  height: 24px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const CheckedIcon = styled.img`
  width: 24px;
  height: 24px;
`;

const UncheckedIcon = styled.img`
  width: 24px;
  height: 24px;
`;

const AgreementText = styled.div`
  flex: 1;
  font-size: 15px;
  font-weight: 600;
  color: #131313;
  display: flex;
  align-items: center;
  gap: 4px;
`;

const RequiredBadge = styled.span`
  color: #fe7156;
  font-weight: 600;
`;

const OptionalBadge = styled.span`
  color: #999;
  font-weight: 600;
`;

const ViewLink = styled.button`
  background: none;
  border: none;
  color: #e31c20;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  margin-left: 8px;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const AgreementModalFooter = styled.div`
  padding: 20px;
  border-top: 1px solid #eee;
`;

const AgreementNextButton = styled(motion.button)`
  width: 100%;
  height: 56px;
  border-radius: 12px;
  background: ${(props) => (props.disabled ? "#E0898A" : "#E31C20")};
  color: ${(props) => (props.disabled ? "#DDC2C2" : "white")};
  font-size: 16px;
  font-weight: 600;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  border: none;
  opacity: 1;
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
`;

// 이용약관/개인정보 처리방침 모달 스타일
const TermsModalOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 1001;
  touch-action: none;

  @media (min-width: 769px) {
    align-items: center;
  }
`;

const TermsModalContainer = styled(motion.div)`
  width: 100%;
  max-width: 500px;
  background-color: white;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 80vh;

  @media (min-width: 769px) {
    border-radius: 16px;
    max-width: 600px;
    max-height: 90vh;
  }
`;

const TermsModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
  position: sticky;
  top: 0;
  background: white;
  z-index: 1;
`;

const TermsModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
  flex: 1;
  text-align: center;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 28px;
  color: #999;
  padding: 0;
  margin: 0;
  cursor: pointer;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
`;

const TermsModalBody = styled.div`
  padding: 20px;
  overflow-y: auto;
  flex: 1;
  font-size: 14px;
  line-height: 1.8;
`;

// 이용약관 스타일 컴포넌트
const TermsContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: #333;
  font-size: 14px;
  line-height: 1.8;
`;

const TermsIntro = styled.p`
  margin-bottom: 20px;
  line-height: 1.8;
`;

const TermsChapter = styled.div`
  margin-bottom: 24px;
`;

const TermsChapterTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #00285b;
`;

const TermsSection = styled.div`
  margin-bottom: 20px;
`;

const TermsSectionTitle = styled.h4`
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
`;

const TermsText = styled.p`
  margin-bottom: 8px;
  line-height: 1.8;
`;

const TermsList = styled.ul`
  list-style: disc;
  margin-left: 20px;
  margin-bottom: 12px;
  padding-left: 0;

  li {
    margin-bottom: 6px;
    line-height: 1.8;
  }
`;

const TermsFooter = styled.p`
  margin-top: 20px;
  font-size: 13px;
  color: #666;
  line-height: 1.8;
`;

// 마케팅 수신 동의 스타일 컴포넌트
const MarketingContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: #333;
  font-size: 14px;
  line-height: 1.8;
`;

const MarketingIntro = styled.p`
  margin-bottom: 20px;
  line-height: 1.8;
`;

const MarketingSection = styled.div`
  margin-bottom: 20px;
`;

const MarketingSectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
`;

const MarketingText = styled.p`
  margin-bottom: 8px;
  line-height: 1.8;
`;

// 개인정보 처리방침 스타일 컴포넌트
const PrivacyContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: #333;
  font-size: 14px;
  line-height: 1.8;
`;

const PrivacyIntro = styled.p`
  margin-bottom: 20px;
  line-height: 1.8;
`;

const PrivacySection = styled.div`
  margin-bottom: 20px;
`;

const PrivacySectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #333;
`;

const PrivacyText = styled.p`
  margin-bottom: 8px;
  line-height: 1.8;
`;

const PrivacyList = styled.ul`
  list-style: disc;
  margin-left: 20px;
  margin-bottom: 12px;
  padding-left: 0;

  li {
    margin-bottom: 6px;
    line-height: 1.8;
  }
`;

const PrivacyTableWrapper = styled.div`
  overflow-x: auto;
  margin: 15px 0;
`;

const PrivacyTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;
  font-size: 13px;
  min-width: 600px;

  thead {
    background-color: #f5f5f5;
  }

  th {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
    font-weight: 600;
    background-color: #f5f5f5;
  }

  td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }

  tr {
    &:nth-child(even) {
      background-color: #fafafa;
    }
  }
`;

const PrivacyContactInfo = styled.div`
  margin: 12px 0;
  padding: 12px;
  background-color: #f9f9f9;
  border-radius: 4px;
  line-height: 1.8;

  strong {
    font-weight: 600;
    display: block;
    margin-bottom: 8px;
  }
`;

const PrivacyFooter = styled.p`
  margin-top: 20px;
  font-size: 13px;
  color: #666;
  line-height: 1.8;
`;

const TermsModalFooter = styled.div`
  padding: 15px 20px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: center;
  position: sticky;
  bottom: 0;
  background: white;
`;

const TermsConfirmButton = styled(motion.button)`
  width: 100%;
  height: 56px;
  border-radius: 12px;
  background: #e31c20;
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  border: none;
`;

// 중앙 모달 스타일
const CenterModalOverlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
  padding: 20px;
`;

const CenterModalContainer = styled(motion.div)`
  width: 100%;
  max-width: 400px;
  background-color: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
`;

const CenterModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  padding: 24px 24px 16px;
  margin: 0;
  text-align: left;
`;

const CenterModalBody = styled.div`
  padding: 0 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const CenterModalText = styled.p`
  font-size: 14px;
  color: #000;
  line-height: 1.3;
  margin: 0;
  text-align: left;
`;

const BoldText = styled.span`
  font-weight: 700;
`;

const CenterModalFooter = styled.div`
  padding: 0 24px 24px;
  display: flex;
  gap: 8px;
`;

const CenterModalButton = styled(motion.button)`
  flex: 1;
  height: 48px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  border: ${(props) => (props.$isCancel ? "1px solid #e5e5e5" : "none")};
  background: ${(props) => (props.$isCancel ? "white" : "#E31C20")};
  color: ${(props) => (props.$isCancel ? "#333" : "white")};
`;

// 토스트 애니메이션 variants
const toast2Variants = {
  initial: {
    opacity: 0,
    y: -80,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.3,
    },
  },
  exit: {
    opacity: 0,
    y: -80,
    transition: {
      duration: 0.3,
    },
  },
};

const Toast2 = styled(motion.div)`
  position: fixed;
  top: 230px;
  left: 5%;
  /* 데스크탑에서는 32%로 위치 조정 */
  @media (min-width: 768px) {
    left: 40%;
  }

  transform: translateX(-50%);
  background-color: rgba(46, 56, 64, 0.9);
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-size: 14px;
  z-index: 1000;
  min-width: 90%;
  max-width: 90%;
  text-align: left;

  @media (min-width: 768px) {
    min-width: auto;
    max-width: 400px;
    width: auto;
  }
`;

const AlertIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background-color: #e31c20;
  color: white;
  border-radius: 50%;
  margin-right: 8px;
  font-size: 16px;
  font-weight: bold;
`;

export default IdentityVerificationInputPage;
